import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Flame, CheckCircle } from "@phosphor-icons/react";

export default function StreakCard({ refreshKey }) {
  const [s, setS] = useState(null);

  useEffect(() => {
    api.get("/entries/stats/streak").then((r) => setS(r.data)).catch(() => setS(null));
  }, [refreshKey]);

  if (!s) return null;

  const alive = s.current_streak > 0;
  const headline = alive
    ? `${s.current_streak} day${s.current_streak > 1 ? "s" : ""} in a row`
    : "Start a new streak";
  const sub = !alive
    ? "Write today and the count begins."
    : s.wrote_today
      ? "Nice — today's entry is in the books."
      : "Write today to keep the streak alive.";

  return (
    <div
      data-testid="streak-card"
      className={`border rounded-lg p-5 grid grid-cols-[auto_1fr_auto] items-center gap-4 transition-colors ${
        alive
          ? "bg-accent/10 border-accent/40"
          : "bg-card border-border"
      }`}
    >
      <div
        className={`h-12 w-12 rounded-full flex items-center justify-center ${
          alive ? "bg-accent/20 text-accent" : "bg-muted text-muted-foreground"
        }`}
      >
        {alive ? <Flame size={24} weight="fill" /> : <Flame size={22} weight="duotone" />}
      </div>
      <div className="min-w-0">
        <p
          data-testid="streak-headline"
          className={`font-serif text-2xl leading-tight ${alive ? "text-foreground" : "text-muted-foreground"}`}
        >
          {headline}
        </p>
        <p className="text-xs text-muted-foreground mt-1">{sub}</p>
      </div>
      <div className="text-right">
        <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Best</p>
        <p data-testid="streak-longest" className="font-serif text-2xl mt-1">
          {s.longest_streak}
        </p>
      </div>
    </div>
  );
}
